"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkStatusAndParseJson = checkStatusAndParseJson;
exports.baseFetchPromiseWithResponse = baseFetchPromiseWithResponse;
exports.baseFetchPromiseWithUnparsedResponse = baseFetchPromiseWithUnparsedResponse;
exports.baseFetchPromiseWithNoResponse = baseFetchPromiseWithNoResponse;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function throwError(httpResult) {
  var error = new Error(httpResult);
  error.response = httpResult.statusText;
  error.statusCode = httpResult.status;
  error.httpResult = httpResult;
  throw error;
} // eslint-disable-next-line complexity


function checkStatusAndParseJson(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.json ? response.json() : {};
  }

  return throwError(response);
}

function checkStatusAndReturnResponse(response) {
  if (response.status >= 200 && response.status < 300) {
    return response.text();
  }

  return throwError(response);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return;
  }

  throwError(response);
}

function baseFetchPromiseWithResponse(uri, options) {
  return (0, _isomorphicFetch["default"])(uri, options).then(function (response) {
    if (response.redirect) {
      response.status = 403;
    }

    return checkStatusAndParseJson(response);
  });
}

function baseFetchPromiseWithUnparsedResponse(uri, options) {
  return (0, _isomorphicFetch["default"])(uri, options).then(function (response) {
    if (response.redirect) {
      response.status = 403;
    }

    return checkStatusAndReturnResponse(response);
  });
}

function baseFetchPromiseWithNoResponse(uri, options) {
  return (0, _isomorphicFetch["default"])(uri, options).then(function (response) {
    if (response.redirect) {
      response.status = 403;
    }

    return checkStatus(response);
  });
}